import React from 'react';
import { AxesHelper, RepeatWrapping, Vector2 } from 'three';
import { TextureLoader } from 'three/src/loaders/TextureLoader';

import { Plane } from '@react-three/drei';
import { useLoader } from '@react-three/fiber';
import { isInDebugMode } from '../../util';

const SCALE = 100;

const Ground = React.memo(() => {
  const colorMap = useLoader(TextureLoader, '/assets/3d/box-tex.jpg');
  colorMap.repeat = new Vector2(SCALE, SCALE);
  colorMap.wrapS = RepeatWrapping;
  colorMap.wrapT = RepeatWrapping;
  return (
    <>
      {isInDebugMode() && <primitive object={new AxesHelper(1)} />}
      <Plane
        rotation={[-Math.PI / 2, 0, 0]}
        scale={SCALE}
        position={[0, -0.06, 0]}
        receiveShadow
      >
        <meshStandardMaterial map={colorMap} />
        {/* <meshPhysicalMaterial
        normalScale={new Vector2(2, 2)}
        metalness={0}
        specularColor={'#fefefe'}
        sheen={4}
        map={new Texture()}
        reflectivity={0}
        color="#bbb"
      /> */}
      </Plane>
    </>
  );
});

export default Ground;
